import { useI18n, t } from "@bookingcom/lingojs-react";
export default function () {
    const i18n = useI18n();
    const getCountryNameFrom = (countryCode) => {
        return i18n.trans(t("country", countryCode, "name_from"));
    };
    const getCountryNameArticle = (countryCode) => {
        return i18n.trans(t("country", countryCode, "name_article"));
    };
    const getCountryName = (countryCode) => {
        return i18n.trans(t("country", countryCode, "name"));
    };
    const getCountryNameIn = (countryCode) => {
        return i18n.trans(t("country", countryCode, "name_in"));
    };
    return {
        getCountryName,
        getCountryNameArticle,
        getCountryNameFrom,
        getCountryNameIn
    };
}
